import { createWebHistory, createRouter } from "vue-router";
import { setPageMeta } from '../utilities/meta'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '' },
    component: () => import(  '../views/public/page')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>  import ('../views/login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () =>  import ('../views/logout.vue')
  },



  {
    path: '/find-a-salon',
    name: 'Find a Salon',
    meta: { title: 'Find a Salon', description: 'Find your nearest Just Cuts salon. No appointments — just walk in for a Style Cut from $35.' },
    component: () =>  import ('../views/public/find-a-salon/index.vue')
  },
  {
    path: '/find-a-salon/:id',
    name: 'Salon',
    component: () =>  import ('../views/public/find-a-salon/show.vue')
  },
  {
    path: '/find-a-career',
    name: 'Find a Career',
    meta: { title: 'Find a Career', description: 'Explore hairdressing careers and Stylist jobs at Just Cuts salons. Walk-in model, ongoing training and real career progression.' },
    component: () =>  import ('../views/public/find-a-career/index.vue')
  },
  {
    path: '/find-a-career/:id',
    name: 'Career',
    component: () =>  import ('../views/public/find-a-career/show.vue')
  },
  {
    path: '/contact',
    name: 'Contact Us',
    meta: { title: 'Contact Us', description: "Get in touch with Just Cuts. Questions about salons, careers or franchising — we're here to help." },
    component: () =>  import ('../views/public/contact.vue')
  },
  {
    path: '/promotions',
    name: 'Store Promotions',
    meta: { title: 'Promotions', description: 'Discover the latest Just Cuts promotions, offers and JUSTICE professional product deals.' },
    component: () =>  import ('../views/public/promotions/index.vue')
  },


  {
    path: '/franchising/opportunities',
    name: 'Franchising Opportunities',
    meta: { title: 'Franchising Opportunities', description: 'Own a Just Cuts franchise. Explore available salon franchise opportunities and start your business journey.' },
    component: () =>  import ('../views/public/franchising-opportunities/index.vue')
  },
  {
    path: '/franchising/opportunities/franchise-details/:id',
    name: 'Franchising Opportunity',
    component: () =>  import ('../views/public/franchising-opportunities/show.vue')
  },
  {
    path: '/franchising/enquiry-form',
    name: 'Enquiry',
    meta: { title: 'Franchise Enquiry', description: 'Enquire about owning a Just Cuts franchise. Submit your details and our team will be in touch.' },
    component: () =>  import ('../views/public/enquiry.vue')
  },
  {
    path: '/franchising/confidential-enquiry',
    name: 'Confidential Enquiry',
    meta: { requires_auth: true },
    component: () =>  import ('../views/public/confidential-enquiry.vue')
  },
  {
    path: '/franchising/testimonials',
    name: 'Testimonials & Reviews',
    meta: { title: 'Testimonials & Reviews', description: 'Read testimonials and reviews from Just Cuts franchise owners and Stylists.' },
    component: () =>  import ('../views/public/testimonials/index')
  },
  {
    path: '/franchising/testimonials/:id',
    name: 'Testimonial',
    component: () =>  import ('../views/public/testimonials/show')
  },
  {
    path: '/franchising/news',
    name: 'All News',
    meta: { title: 'Franchising News', description: 'The latest Just Cuts franchising news, updates and media.' },
    component: () =>  import ('../views/public/articles/index.vue')
  },
  {
    path: '/franchising/news/:id',
    name: 'News Article',
    component: () =>  import ('../views/public/articles/show.vue')
  },




  {
    path: '/restricted',
    name: 'Restricted',
    component: () =>  import ('../views/public/restricted.vue')
  },
  {
    name: 'Admin Dashboard',
    path: '/admin',
    meta: { requires_auth: true, requires_admin: true, },
    component: () => import('../views/admin/dashboard'),
    children: [
      {
        name: 'Dashboard',
        path: '',
        meta: { hide_admin_link: true },
        component: () => import('../views/admin/admin_home/admin_home'),
      },
      {
        name: 'Salons',
        path: 'salons',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Salons',
            path: '',
            meta: { links: ['/admin/salons/new'] },
            component: () => import('../views/admin/salons/index')
          },
          {
            name: 'New Salon',
            path: 'new',
            meta: { links: ['/admin/salons'] },
            component: () => import('../views/admin/salons/edit')
          },
          {
            name: 'Edit Salon',
            path: ':id',
            meta: { links: ['/admin/salons'] },
            component: () => import('../views/admin/salons/edit')
          }
        ]
      },
      {
        name: 'Careers',
        path: 'careers',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Careers',
            path: '',
            meta: { links: ['/admin/careers/new'] },
            component: () => import('../views/admin/careers/index')
          },
          {
            name: 'New Career',
            path: 'new',
            meta: { links: ['/admin/careers'] },
            component: () => import('../views/admin/careers/edit')
          },
          {
            name: 'Edit Career',
            path: ':id',
            meta: { links: ['/admin/careers'] },
            component: () => import('../views/admin/careers/edit')
          }
        ]
      },
      {
        name: 'Career Applications',
        path: 'career_applications',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Career Applications',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/career_applications/index')
          },
          {
            name: 'Career Application',
            path: ':id',
            meta: { links: ['/admin/career_applications'] },
            component: () => import('../views/admin/career_applications/show')
          }
        ]
      },
      {
        name: 'Promotions',
        path: 'promotions',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'View Promotions',
            path: '',
            meta: { links: ['/admin/promotions/new'] },
            component: () => import('../views/admin/promotions/index')
          },
          {
            name: 'New Promotion',
            path: 'new',
            meta: { links: ['/admin/promotions'] },
            component: () => import('../views/admin/promotions/edit')
          },
          {
            name: 'Edit Promotion',
            path: ':id',
            meta: { links: ['/admin/promotions'] },
            component: () => import('../views/admin/promotions/edit')
          }
        ]
      },
      {
        name: 'Pages',
        path: 'pages',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Pages',
            path: '',
            meta: { links: ['/admin/pages/new'] },
            component: () => import('../views/admin/pages/index')
          },
          {
            name: 'New Page',
            path: 'new',
            meta: { links: ['/admin/pages'] },
            component: () => import('../views/admin/pages/edit')
          },
          {
            name: 'Edit Page',
            path: ':id',
            meta: { links: ['/admin/pages'] },
            component: () => import('../views/admin/pages/edit')
          }
        ]
      },

      {
        name: 'Notifications',
        path: 'notifications',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Notification Subscribers',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/notifications/index')
          }
        ]
      },
      {
        name: 'Contact Submissions',
        path: 'contacts',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Contacts Submissions',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/contacts/index')
          },
          {
            name: 'Contact',
            path: ':id',
            meta: { links: ['/admin/contacts'] },
            component: () => import('../views/admin/contacts/show')
          }
        ]
      },

      {
        name: 'Snippet Testimonials',
        path: 'testimonials',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Snippet Testimonials',
            path: '',
            meta: { links: ['/admin/testimonials/new'] },
            component: () => import('../views/admin/testimonials/index')
          },
          {
            name: 'New Snippet Testimonial',
            path: 'new',
            meta: { links: ['/admin/testimonials'] },
            component: () => import('../views/admin/testimonials/edit')
          },
          {
            name: 'Edit Snippet Testimonial',
            path: ':id',
            meta: { links: ['/admin/testimonials'] },
            component: () => import('../views/admin/testimonials/edit')
          }
        ]
      },
      {
        name: 'Navigation',
        path: 'navigation',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Navigation Lists',
            path: '',
            meta: { links: ['/admin/navigation/new'] },
            component: () => import('../views/admin/navigation/index')
          },
          {
            name: 'Edit Navigation List',
            path: ':id',
            meta: { links: ['/admin/navigation'] },
            component: () => import('../views/admin/navigation/edit')
          }
        ]
      },
      {
        name: 'Email Settings',
        path: 'email_settings',
        component: () => import('../views/admin/email_settings'),
      },
      {
        name: 'Users',
        path: 'users',
        component: () => import('../views/admin/users'),
      },
      {
        name: 'Franchising',
        path: 'franchising',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Franchise Opportunities',
            path: 'opportunities',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'Franchise Opportunities',
                path: '',
                meta: { links: ['/admin/franchising/opportunities/new'] },
                component: () => import('../views/admin/franchising/franchise_opportunities/index')
              },
              {
                name: 'New Franchise Opportunity',
                path: 'new',
                meta: { links: ['/admin/franchising/opportunities'] },
                component: () => import('../views/admin/franchising/franchise_opportunities/edit')
              },
              {
                name: 'Edit Franchise Opportunity',
                path: ':id',
                meta: { links: ['/admin/franchising/opportunities'] },
                component: () => import('../views/admin/franchising/franchise_opportunities/edit')
              }
            ]
          },
          {
            name: 'Franchise Enquires',
            path: 'enquires',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'Franchise Enquires',
                path: '',
                meta: { links: ['/admin/franchising/enquires/import'] },
                component: () => import('../views/admin/franchising/franchise_enquires/index')
              },
              {
                name: 'Franchise Enquiry',
                path: ':id',
                meta: { links: ['/admin/franchise_enquires'] },
                component: () => import('../views/admin/franchising/franchise_enquires/show')
              },
              {
                name: 'Import Franchise Enquiries',
                path: 'import',
                meta: { links: ['/admin/franchise_enquires'] },
                component: () => import('../views/admin/franchising/franchise_enquires/import')
              }
            ]
          },
          {
            name: 'Financial Submissions',
            path: 'submissions',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'Financial Submissions',
                path: '',
                meta: { links: [] },
                component: () => import('../views/admin/franchising/financial_submissions/index')
              },
              {
                name: 'Financial Submission',
                path: ':user_id',
                meta: { links: ['/admin/financial_submissions'] },
                component: () => import('../views/admin/franchising/financial_submissions/show')
              }
            ]
          },
          {
            name: 'Frachising News',
            path: 'articles',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'News',
                path: '',
                meta: { links: ['/admin/franchising/articles/new'] },
                component: () => import('../views/admin/articles/index')
              },
              {
                name: 'New News Article',
                path: 'new',
                meta: { links: ['/admin/franchising/articles'] },
                component: () => import('../views/admin/articles/edit')
              },
              {
                name: 'Edit News Article',
                path: ':id',
                meta: { links: ['/admin/franchising/articles'] },
                component: () => import('../views/admin/articles/edit')
              }
            ]
          },
          {
            name: 'Franchising Testimonials',
            path: 'case_studies',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'Page Testimonials',
                path: '',
                meta: { links: ['/admin/franchising/case_studies/new'] },
                component: () => import('../views/admin/case_studies/index')
              },
              {
                name: 'New Page Testimonial',
                path: 'new',
                meta: { links: ['/admin/franchising/case_studies'] },
                component: () => import('../views/admin/case_studies/edit')
              },
              {
                name: 'Edit Page Testimonial',
                path: ':id',
                meta: { links: ['/admin/franchising/case_studies'] },
                component: () => import('../views/admin/case_studies/edit')
              }
            ]
          },
          {
            name: 'Frachising Staff Bios',
            path: 'staff_bios',
            component: () => import('../views/admin/view_group'),
            children: [
              {
                name: 'Staff Bios',
                path: '',
                meta: { links: ['/admin/franchising/staff_bios/new'] },
                component: () => import('../views/admin/staff_bios/index')
              },
              {
                name: 'New Staff Bio',
                path: 'new',
                meta: { links: ['/admin/franchising/staff_bios'] },
                component: () => import('../views/admin/staff_bios/edit')
              },
              {
                name: 'Edit Staff Bio',
                path: ':id',
                meta: { links: ['/admin/franchising/staff_bios'] },
                component: () => import('../views/admin/staff_bios/edit')
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page',
    meta: { some_meta_variable: 'whatever' },
    component: ()  => import('../views/public/page')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Baseline per-route SEO. Components for dynamic pages (salon / career / news /
// opportunity / content page) call setPageMeta() again once their DB data loads,
// overriding this default with record-specific title, description and image.
router.afterEach((to) => {
  // Admin pages live behind auth and must never be indexed.
  if (to.matched.some(r => r.meta && r.meta.requires_admin)) {
    setPageMeta({ title: to.meta.title || (to.name ? String(to.name) : null), noindex: true });
    return;
  }

  // The catch-all "Page" route renders DB content pages and sets its own meta,
  // so don't impose a route-name title on it here.
  const isContentPage = to.name === 'Page';
  const title = (to.meta && to.meta.title !== undefined)
    ? to.meta.title
    : (!isContentPage && to.name ? String(to.name) : null);

  setPageMeta({
    title,
    description: to.meta && to.meta.description,
    path: to.fullPath.split('?')[0]
  });
});

// GA4 page_view tracking for SPA navigations. The gtag library is loaded in
// public/index.html with send_page_view:false, so this hook is the single source
// of page_views — exactly one per route change, including the initial load.
// Registered after the SEO hook above so document.title is already updated.
router.afterEach((to) => {
  if (typeof window.gtag !== 'function') return;
  const path = to.fullPath;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title
  });
});

router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0);


  const requires_auth = to.matched.some(x => x.meta.requires_auth);
  const requires_admin = to.matched.some(x => x.meta.requires_admin);

  //console.log("route", {requires_auth: requires_auth }, {requires_admin: requires_admin}, to.fullPath)


  // console.log("route", { name:to.name, path: to.fullPath, requires_auth: requires_auth, auth_session: router.$store.getters.auth_session });

 // next(); return; // for debug

  if (!requires_auth && !requires_admin) {

   // console.log("next");
    next();

  } else if (requires_admin && router.$store.getters.auth_session &&
                              router.$store.getters.auth_session.user &&
                              router.$store.getters.auth_session.user.app_metadata.is_admin){
    next();

  } else if(!requires_admin && requires_auth && router.$store.getters.auth_session &&
                                                router.$store.getters.auth_session.user) {
    next();
  }

  else if (router.$store.getters.auth_session && router.$store.getters.auth_session.user ){

    console.log("---restricted--")
    next(`/restricted`);

  } else {
     next(`/login?destination=${to.path}`);

  }
});

export default router


